import { z } from 'zod';

const grammarClipResponseSchemaDefinition = z.object({
  id: z.number().int(),
  challengeId: z.number().int(),
  collectionId: z.number().int().nullable(),
  durationMs: z.number().int(),
  transcript: z.string().nullable(),
  startMs: z.number().int().nullable(),
  endMs: z.number().int().nullable(),
  basePath: z.string().nullable(),
  verticalPath: z.string().nullable(),
});

export const grammarClipResponseSchema: typeof grammarClipResponseSchemaDefinition =
  grammarClipResponseSchemaDefinition;

export type IGrammarClipResponse = z.infer<typeof grammarClipResponseSchema>;
